module.exports = __webpack_public_path__ + "img/the_5am_club.ac109eeb.jpg";